import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import type { RouteStateType } from '@redux/types'

const initialState: RouteStateType = {
	// path
	currentPath: '',
	navigatePath: '',
	contentsSiteBlackList: [
		'/admin',
		'/auth',
		'/admin/empty',
		'/main/empty',
		'/main/home',
		'/admin/home',
	],
	totalRoutePaths: [],

	// tab
	removeTabIdx: -1,
}

const slice = createSlice({
	name: 'route',
	initialState,
	reducers: {
		// path
		CURRENT_PATH: (state: RouteStateType, action: PayloadAction<string>) => {
			state.currentPath = action.payload
		},
		NAVIGATE_PATH: (state: RouteStateType, action: PayloadAction<string>) => {
			state.navigatePath = action.payload
		},
		TOTAL_ROUTE_PATHS: (state: RouteStateType, action: PayloadAction<string[]>) => {
			state.totalRoutePaths = action.payload
		},

		// tab
		REMOVE_TAB_IDX: (state: RouteStateType, action: PayloadAction<number>) => {
			state.removeTabIdx = action.payload
		},
	},
})

export const routeActions = slice.actions
export default slice.reducer
